import { render } from "./VideoReferenceModal.vue?vue&type=template&id=656413fe&scoped=true"
import script from "./VideoReferenceModal.vue?vue&type=script&lang=js"
export * from "./VideoReferenceModal.vue?vue&type=script&lang=js"

import "./VideoReferenceModal.vue?vue&type=style&index=0&id=656413fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-656413fe"

export default script